import express from "express";
import { getServerHelpers, getUniversalHelpers } from "../../helpers";
import { validateToken, validateTokenAndEnsureSelfAccountIdMatches } from "../../internal-utils/server-auth";
import { SendMessageToSlackChannel } from "../../utils/slack-utils";

export async function olliePipe__server__sendOlliePipeEvent(p: {
  type: string;
  payload: any;
  slackImportantErrorsMessage?: string;
}) {
  // SERVER_ONLY_TOGGLE
  const { olliePipe } = getUniversalHelpers();
  const { channels } = getServerHelpers();
  await olliePipe.emitEvent({
    payload: p.payload,
    type: p.type
  });

  if (p.slackImportantErrorsMessage) {
    try {
      SendMessageToSlackChannel({
        channel: "#important-errors",
        message: p.slackImportantErrorsMessage
      });
    } catch (e) {
      // Don't blow up
      await olliePipe.emitEvent({
        payload: p.payload,
        type: "error-logging-to-slack-important-channels"
      });
    }
  }
  // SERVER_ONLY_TOGGLE
}

olliePipe__server__sendOlliePipeEvent.auth = async (r: any) => {};

// i18n certified - complete
